import PropTypes from 'prop-types'
import { useHistory } from 'react-router'

const ReportingCategoryItem = ({
  name,
  uuid,
  assignedItemsLength,
}) => {
  const onClickItem = () =>
    history.push({
      state: { reportingCategoryUuid: uuid },
    })

  const history = useHistory()
  return (
    <div className="item" role="button" onClick={onClickItem}>
      <div className="row">
        <div className="item-info-wrapper">{name}</div>
        <div className="item-info-wrapper">
          {assignedItemsLength ?? 0}
        </div>
      </div>
    </div>
  )
}

ReportingCategoryItem.propTypes = {
  name: PropTypes.string,
  uuid: PropTypes.string,
  assignedItemsLength: PropTypes.number,
}

export default ReportingCategoryItem
